import { __isEmpty } from './';

export const isEmpty = (obj: Object = {}) => __isEmpty(obj);

// export const isEmpty = (obj: Object = {}) => (__isEmpty(obj) ? false : obj);
